var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoImportedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.33332V14.6667C18 17.1667 16.75 18.8333 13.8333 18.8333H7.16667C4.25 18.8333 3 17.1667 3 14.6667V6.33332C3 3.83332 4.25 2.16666 7.16667 2.16666H13.8333C16.75 2.16666 18 3.83332 18 6.33332Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 4.25V5.91667C12.5833 6.83333 13.3333 7.58333 14.2499 7.58333H15.9166",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16675 11.3333H10.5001",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16675 14.6667H13.8334",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoImportedIcon);
export default __webpack_public_path__ + "static/media/auto_imported_icon.4c3594f9624e92b3e4c4993e2c36eb2a.svg";
export { ForwardRef as ReactComponent };